var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 40 40" }, props),
    React.createElement(
      "defs",
      null,
      React.createElement(
        "filter",
        { id: "a", width: "147.5%", height: "147.5%", x: "-23.8%", y: "-21.2%", filterUnits: "objectBoundingBox" },
        React.createElement("feOffset", { dy: "1", "in": "SourceAlpha", result: "shadowOffsetOuter1" }),
        React.createElement("feGaussianBlur", { "in": "shadowOffsetOuter1", result: "shadowBlurOuter1", stdDeviation: "3" }),
        React.createElement("feColorMatrix", { "in": "shadowBlurOuter1", result: "shadowMatrixOuter1", values: "0 0 0 0 0.431372549 0 0 0 0 0.431372549 0 0 0 0 0.431372549 0 0 0 0.528730752 0" }),
        React.createElement(
          "feMerge",
          null,
          React.createElement("feMergeNode", { "in": "shadowMatrixOuter1" }),
          React.createElement("feMergeNode", { "in": "SourceGraphic" })
        )
      )
    ),
    React.createElement(
      "g",
      { fill: "none", fillRule: "evenodd", filter: "url(#a)" },
      React.createElement("circle", { cx: "20", cy: "20", r: "20", fill: "#B9B9B9" }),
      React.createElement("path", { fill: "#FFF", d: "M15.45 15.88v2.62H14.4c-.77 0-1.4.67-1.4 1.5v7.5c0 .83.63 1.5 1.4 1.5h11.2c.77 0 1.4-.67 1.4-1.5V20c0-.83-.63-1.5-1.4-1.5h-1.05v-2.63c0-2.69-2.04-4.87-4.55-4.87s-4.55 2.18-4.55 4.88zM17.67 19v-2.8c0-1.77 1.25-3.2 2.8-3.2s2.8 1.43 2.8 3.2V19h-5.6zm.93 3.43c0-.8.63-1.43 1.4-1.43a1.44 1.44 0 1 1 .76 2.63l.29 1.83a.53.53 0 0 1-.53.54h-1.05a.53.53 0 0 1-.52-.54l.29-1.83a1.43 1.43 0 0 1-.64-1.2z" })
    )
  );
});